import mediaQueries from 'styles/mediaQueries';
import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';

type Props = {
  'data-test'?: string;
};

const LeftButtonGroupControls = styled('div')<Props>({
  display: 'inherit',
  height: '4rem',
  [mediaQueryBuilder([
    mediaQueries.max.height['99'],
    mediaQueries.min.width['399'],
  ])]: {
    marginLeft: 'auto',
  },
});

export default LeftButtonGroupControls;
